
import { ThumbsUp } from "lucide-react";

interface ContactedProviderBadgeProps {
  contacted: boolean;
}

const ContactedProviderBadge = ({ contacted }: ContactedProviderBadgeProps) => {
  if (!contacted) return null;
  
  return (
    <div className="mt-4">
      <span className="inline-flex items-center text-xs px-2 py-1 bg-whatsapp-light text-whatsapp rounded-full">
        <ThumbsUp className="h-3 w-3 mr-1" />
        User contacted this provider
      </span>
    </div>
  );
};

export default ContactedProviderBadge;
